export function iconForMime(mime) {
  if (!mime) return "fa-file";
  if (mime.startsWith("image/")) return "fa-file-image";
  if (mime.startsWith("video/")) return "fa-file-video";
  if (mime.startsWith("audio/")) return "fa-file-audio";
  if (mime === "application/pdf") return "fa-file-pdf";
  if (mime.includes("zip") || mime.includes("compressed") || mime.includes("tar")) return "fa-file-archive";
  if (mime.includes("word") || mime.includes("document")) return "fa-file-word";
  if (mime.includes("sheet") || mime.includes("excel") || mime.includes("spreadsheet")) return "fa-file-excel";
  if (mime.includes("presentation") || mime.includes("powerpoint")) return "fa-file-powerpoint";
  if (mime.startsWith("text/")) return "fa-file-alt";
  return "fa-file";
}

export function colorForMime(mime) {
  if (!mime) return { bg: "#f5f5f5", color: "#616161" };

  if (mime.startsWith("image/")) return { bg: "#e3f2fd", color: "#1e88e5" };
  if (mime.startsWith("video/")) return { bg: "#f3e5f5", color: "#8e24aa" };
  if (mime.startsWith("audio/")) return { bg: "#e0f2f1", color: "#00897b" };

  if (mime === "application/pdf") return { bg: "#fdecea", color: "#d32f2f" };

  if (mime.includes("zip") || mime.includes("compressed"))
    return { bg: "#f1f8e9", color: "#558b2f" };

  if (mime.includes("word"))
    return { bg: "#e3f2fd", color: "#1565c0" };

  if (mime.includes("sheet") || mime.includes("excel"))
    return { bg: "#e8f5e9", color: "#2e7d32" };

  if (mime.includes("presentation"))
    return { bg: "#fff3e0", color: "#ef6c00" };

  return { bg: "#f5f5f5", color: "#616161" };
}

export function isInlineViewableMime(mime) {
  return mime === "application/pdf";
}

// Human-readable file type for display next to the size — "PDF", "XLSX",
// "PNG" rather than raw MIME like "application/pdf". Filename extension is
// the most reliable source (it's what users actually recognize); MIME is
// the fallback when the filename has no extension.
export function readableFileType(mime, fileName) {
  if (fileName) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex > 0 && dotIndex < fileName.length - 1) {
      const ext = fileName.slice(dotIndex + 1).toUpperCase();
      if (ext.length <= 5 && /^[A-Z0-9]+$/.test(ext)) return ext;
    }
  }
  if (!mime) return "FILE";
  const m = String(mime).toLowerCase();
  if (m === "application/pdf") return "PDF";
  if (m === "application/msword") return "DOC";
  if (m === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return "DOCX";
  if (m === "application/vnd.ms-excel") return "XLS";
  if (m === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return "XLSX";
  if (m === "application/vnd.ms-powerpoint") return "PPT";
  if (m === "application/vnd.openxmlformats-officedocument.presentationml.presentation") return "PPTX";
  if (m === "application/json") return "JSON";
  if (m === "text/plain") return "TXT";
  if (m === "text/csv") return "CSV";
  if (m === "text/markdown") return "MD";
  if (m.includes("zip")) return "ZIP";
  if (m.includes("rar")) return "RAR";
  if (m.includes("tar")) return "TAR";
  if (m.includes("7z")) return "7Z";
  if (m.startsWith("image/") || m.startsWith("video/") || m.startsWith("audio/") || m.startsWith("text/")) {
    const sub = m.split("/")[1] || "";
    const cleaned = sub.replace(/^x-/, "").split(";")[0].split("+")[0];
    if (cleaned) return cleaned.toUpperCase();
  }
  return "FILE";
}

const ATTACHMENT_POLICY_KEYS = Object.freeze({
  thread: "InteractionsAttachmentPolicyThread",
  comment: "InteractionsAttachmentPolicyComment",
});

const DENY_POLICY = Object.freeze({
  isAllowed: false,
  maxFileSizeMB: 0,
  maxCount: 0,
  allowedTypes: [],
});

export function resolveAttachmentPolicy(systemParameters, entityType) {

  const key = ATTACHMENT_POLICY_KEYS[entityType];
  if (!key || !systemParameters) return DENY_POLICY;

  const raw = systemParameters[key];
  if (raw == null) return DENY_POLICY;

  // SystemParameters values may arrive pre-parsed or as a raw string.
  let parsed = raw;
  if (typeof raw === "string") {
    try { parsed = JSON.parse(raw); } catch (_) { return DENY_POLICY; }
  }
  if (!parsed || typeof parsed !== "object") return DENY_POLICY;

  return {
    isAllowed: !!parsed.isAllowed,
    maxFileSizeMB: Number(parsed.maxFileSizeMB) || 0,
    maxCount: Number(parsed.maxCount) || 0,
    allowedTypes: Array.isArray(parsed.allowedTypes) ? parsed.allowedTypes : [],
  };
}

export function formatBytes(bytes) {
  const b = Number(bytes) || 0;
  if (b < 1024) return b + " B";
  if (b < 1024 * 1024) return (b / 1024).toFixed(1) + " KB";
  if (b < 1024 * 1024 * 1024) return (b / (1024 * 1024)).toFixed(1) + " MB";
  return (b / (1024 * 1024 * 1024)).toFixed(2) + " GB";
}
